import * as tslib_1 from "tslib";
import { HtmlNode } from "./html-node";
/**
 * @class Autolinker.htmlParser.EntityNode
 * @extends Autolinker.htmlParser.HtmlNode
 *
 * Represents a known HTML entity node that has been parsed by the {@link Autolinker.htmlParser.HtmlParser}.
 * Ex: '&amp;nbsp;', or '&amp#160;' (which will be retrievable from the {@link #getText}
 * method.
 *
 * Note that this class will only be returned from the HtmlParser for the set of
 * checked HTML entity nodes  defined by the {@link Autolinker.htmlParser.HtmlParser#htmlCharacterEntitiesRegex}.
 *
 * See this class's superclass ({@link Autolinker.htmlParser.HtmlNode}) for more
 * details.
 */
var EntityNode = /** @class */ (function (_super) {
    tslib_1.__extends(EntityNode, _super);
    function EntityNode() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * Returns a string name for the type of node that this class represents.
     *
     * @return {String}
     */
    EntityNode.prototype.getType = function () {
        return 'entity';
    };
    return EntityNode;
}(HtmlNode));
export { EntityNode };

//# sourceMappingURL=entity-node.js.map
